import { GetRequisitesResponse } from '@shared/api/rest/payments';
import { SearchHighlight } from '@shared/widgets';
import clsx from 'clsx';

interface RecipientItemType {
  item: GetRequisitesResponse;
  query: string;
  onDelete: (requisite: GetRequisitesResponse) => void;
  onSelect: (requisite: GetRequisitesResponse) => void;
  isActive: boolean;
}

export const RecipientItem = (props: RecipientItemType) => (
  <div
    className={clsx('flex h-[46px] cursor-pointer items-center justify-between', props.isActive ? 'text-[#efefef]' : '')}
    onClick={() => props.onSelect(props.item)}
  >
    <div className='flex items-center justify-start'>
      {props.isActive ? (
        <div className='mr-3'>
          <svg width='18' height='14' viewBox='0 0 18 14' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M17.133 1.106a.338.338 0 0 0-.49 0L6.129 12.03 1.593 7.316a.338.338 0 0 0-.491 0 .37.37 0 0 0 0 .51l4.781 4.968a.34.34 0 0 0 .491 0l10.76-11.178a.37.37 0 0 0 0-.51z'
              fill='#929292'
              stroke='#929292'
              fillRule='evenodd'
            />
          </svg>
        </div>
      ) : null}
      <div>
        <div className='text-[#efefef]'>
          <SearchHighlight searchText={props.query}>{props.item.OwnerName}</SearchHighlight>
        </div>
      </div>
    </div>
    <div
      onClick={(e) => {
        props.onDelete(props.item), e.stopPropagation();
      }}
    >
      <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
        <g fill='#666' fillRule='evenodd'>
          <path d='M.288 14.43L13.976.743l1.2 1.2L1.488 15.63z' />
          <path d='M1.479.734L15.166 14.42l-1.2 1.2L.28 1.934z' />
        </g>
      </svg>
    </div>
  </div>
);
